import { render, staticRenderFns } from "./NormalCreateForm.vue?vue&type=template&id=37a593b9"
import script from "./NormalCreateForm.vue?vue&type=script&lang=js"
export * from "./NormalCreateForm.vue?vue&type=script&lang=js"
import style0 from "./NormalCreateForm.vue?vue&type=style&index=0&id=37a593b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports